module.exports = __webpack_public_path__ + "img/reservation_gift1.77fd2a4e.png";